import { useCallback } from 'react';
import useTranslation from '../../services/translationService';

const interpolate = (text, vars) => (vars && typeof text === 'string'
  ? text.replace(/\{\{(\w+)\}\}/g, (match, name) => (vars[name] !== undefined ? String(vars[name]) : match))
  : text);

/**
 * `t` scoped to `dashboard.*` keys. The translation service returns an English fallback without
 * filling its {{placeholders}}, so they are filled here as well.
 */
export default function useDashboardT() {
  const { t } = useTranslation();
  return useCallback((key, fallback, vars) => interpolate(t(`dashboard.${key}`, vars || {}, fallback), vars), [t]);
}
